import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import useAsync from '../hooks/useAsync';
import TicketServices from '../services/TicketServices';
import ViewTicketDetails from './View Model/ViewTicketDetails';
import DeleteButton from './Button/DeleteButton';
import TicketStatus from './TogelButton/TicketStatus';
import TicketPriority from './TogelButton/TicketPriority';
import Modal from 'react-modal';
import ReactPaginate from 'react-paginate';
import Pagetitle from './PageTitle';
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom';

Modal.setAppElement('#root');

function TicketManagement() {
  const { data, error, isLoading, run } = useAsync(TicketServices.getTicket);
  // console.log(data);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [statusFilter, setStatusFilter] = useState("");


  const ticketPerPage = 10;
  const handleViewDetails = (ticket) => {
    setSelectedUser(ticket);
    setIsModalOpen(true);
  };

  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };
  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
  };
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };


  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return 'N/A';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' }); // Get abbreviated month name
    const year = date.getFullYear().toString();

    return `${day} ${month} ${year}`;
  };

  // const filteredticket = data?.data?.filter(ticket => {
  //   return (
  //     ticket?.ticketId?.toLowerCase().includes(searchQuery?.toLowerCase() || "")
  //   );
  // });
  const filteredticket = data?.data?.filter((ticket) => {
    // Check if the ticket matches the search query for user name
    const matchesSearch = searchQuery
      ? ticket?.user?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      ticket?.user?.mobileNo?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      ticket?.ticketId?.toLowerCase().includes(searchQuery.toLowerCase())
      : true;

    // Check if the ticket matches the selected status filter
    const matchesStatus = statusFilter
      ? ticket?.status?.toLowerCase() === statusFilter.toLowerCase()
      : true;

    // Return true if both conditions are satisfied
    return matchesSearch && matchesStatus;
  });



  // Calculate pagination values
  const indexOfLastUser = currentPage * ticketPerPage;
  const indexOfFirstUser = indexOfLastUser - ticketPerPage;
  const paginatedTicket = filteredticket?.slice(indexOfFirstUser, indexOfLastUser);  // Slice the filtered users for pagination

  const generateExcel = () => {
    const filteredData = filteredticket?.map((ticket, index) => ({
      Sno: index + 1,
      TicketId: ticket?.ticketId,
      IssueType: ticket?.issueType,
      Username: ticket?.user?.name,
      UserMobileNo: ticket?.user?.mobileNo,
      Image: process.env.REACT_APP_URL + ticket?.image,
      Priority: ticket?.priority,
      Description: ticket?.description,
      Date: formatDate(ticket?.createdAt),
      Status: ticket?.status,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'ticket');
    XLSX.writeFile(wb, 'ticket_data.xlsx');
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleStatusChange = (e) => {
    setStatusFilter(e.target.value);
  };

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box px-0 user-manager" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
        <div className="container-box-top-header px-4">
          <div className="container-box-top-header-left-2">
            <input
              type="search"
              name="search"
              placeholder="Search by Ticket Id , Customer Name and mobile No"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="search-btn">
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>

          <div className="sub-title-box-right d-flex">
            <div>
              <select className="dropdown" value={statusFilter}
                onChange={handleStatusChange}  >
                <option value="">Filter by Status</option>
                <option value="InProgress" style={{color:'#F9B842'}}>In Progress</option>
                <option value="Resolved" style={{color:'#699836'}}>Resolved</option>
                <option value="Closed" style={{color:'#FF3333'}}>Closed</option>
              </select>
            </div>
            <button className="excel-btn site-btn-green ms-3" onClick={generateExcel}>
              <img src="img/excel-btn.svg" alt='' />
              <span className='ms-2'>Download</span>
            </button>
          </div>
        </div>
        <div className="container-box-inner">
          <table id="example" className="table table-striped" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Ticket ID</th>
                <th>Image</th>
                <th>User Name</th>
                <th>Mob. No.</th>
                <th> Issue Type</th>
                <th>Priority</th>
                <th>Status</th>
                <th>Date Created</th>
                <th>Last Updated</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedTicket?.map((ticket, index) => (
                <tr key={ticket?._id}>
                  <td>{index + 1 + (currentPage - 1) * ticketPerPage}</td>
                  <td>#{ticket?.ticketId}</td>
                  <td>
                    <div className="product-img">
                      <img
                        src={process.env.REACT_APP_URL + ticket?.image}
                        alt=""
                        style={{ height: '70px', width: '70px', objectFit: 'contain' }}
                      />
                    </div>
                  </td>
                  <td>{ticket?.user?.name ? ticket?.user?.name : 'N/A'}</td>
                  <td>{ticket?.user?.mobileNo}</td>
                  <td>{ticket?.issueType}</td>
                  <td className="status-toggle">
                    <TicketPriority data={ticket} page="Ticket" onSuccess={run} />
                  </td>
                  <td className="status-toggle">
                    <TicketStatus data={ticket} page="Ticket" onSuccess={run} />
                  </td>
                  <td>{formatDate(ticket?.createdAt)}</td>
                  <td>{formatDate(ticket?.updatedAt)}</td>
                  <td>
                    <div className="action_toggle_outer">
                      <button className="action_toggle" onClick={() => toggleActionMenu(index)}>
                        <i className="fa fa-ellipsis-v" />
                      </button>
                      {activeIndex === index && (
                        <div className="action_toggle_content product-edit show d-block">
                          <ul className="list-unstyled">
                            <li>
                              <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                <i className="fa fa-close" />
                              </button>
                            </li>
                            <li>
                              <button className="edit" onClick={() => handleViewDetails(ticket)}>View</button>
                            </li>
                            <li>
                              <button className="reject" onClick={() => handleDelete(ticket)}>Delete</button>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}

            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredticket?.length || 0) / ticketPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={'page-link'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            disabledClassName={'disabled'}
          />
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewTicketDetails ticket={selectedUser} closeModal={closeModal} onSuccess={run} />
      </Modal>
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <DeleteButton data={selectedEdit} page="Ticket" closeModal={closeDeleteModal} onSuccess={run} />
      </Modal>
    </div>
  );
}

export default TicketManagement;
